import { types } from "mobx-state-tree";
import Employee from "./Employee";
import WorkOrder from './WorkOrder'
import shortid from 'shortid'
import { format, differenceInMinutes } from "date-fns";

export default types.model({
  id: types.identifier(types.string),
  employee: types.reference(types.late(() => Employee)),
  workOrder: types.reference(types.late(() => WorkOrder)),
  startedAt: types.Date,
  finishedAt: types.maybe(types.Date)
}).preProcessSnapshot(snapshot => {
  const copy = Object.assign(snapshot)
  if (!copy.id) copy.id = shortid.generate()
  return copy
}).actions(self => ({
  finish(date = new Date()) {
    self.finishedAt = date
  }
})).views(self => ({
  asString() {
    return self.workOrder.asString()
  },
  get isFinished() {
    return self.finishedAt ? true : false
  },
  get formattedDate() {
    return format(self.startedAt, 'DD/MM/YY')
  },
  get formattedStartTime() {
    return format(self.startedAt, 'hh:mm')
  },
  get formattedFinishTime() {
    if (!self.finishedAt) return ''
    return format(self.finishedAt, 'hh:mm')
  },
  get elapsedTimeAsMinutes() {
    if (!self.finishedAt) return 0
    return differenceInMinutes(self.finishedAt, self.startedAt)
  },
  get elapsedTimeAsHours() {
    if (!self.finishedAt) return ''
    // const hours = differenceInHours(self.startedAt, self.finishedAt)
    const minutes = differenceInMinutes(self.finishedAt, self.startedAt)
    const hours = Math.floor(minutes / 60)
    const remainingMinutes = minutes - (hours * 60)
    return hours + ':' + remainingMinutes
  },
}))


// WEBPACK FOOTER //
// ./src/models/Activity.js